export default __webpack_public_path__ + "static/media/regulatory--no-pedestrians--g5.02c0c663.png";